import {
  type QueryClient,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { initializeApi } from 'shared/api/lib';
import { queryKeys } from 'shared/api/model';

export const authInfoQueryOptions = queryOptions({
  queryKey: queryKeys.auth.info.queryKey,
  queryFn: () =>
    initializeApi(import.meta.env.VITE_BACKEND_URL).AuthApi.getAuthInfo(),
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: true,
});

export const ensureAuthInfo = (queryClient: QueryClient) =>
  queryClient.ensureQueryData(authInfoQueryOptions).catch((error: unknown) => {
    if (error instanceof Response && error.status === 401) return null;
    throw error;
  });

export const useGetAuthInfo = () => useQuery(authInfoQueryOptions);
